import React from 'react'
import { useLocation } from 'react-router-dom'

import { Navigate } from '@lib/react-router-dom'

export const RedirectionManager: React.FC = () => {
  const location = useLocation()
  const redirectionPath = new URLSearchParams(location.search).get('redir')

  return redirectionPath ? <Navigate to={`/${redirectionPath}`} replace /> : null
}
